import { useEffect, useState, useRef } from 'react';

const useInfiniteScroll = (data = [], itemsPerPage = 200) => {
  const [visibleData, setVisibleData] = useState([]);
  const [page, setPage] = useState(1);
  const loaderRef = useRef(null);

  const totalPages = Math.ceil(data.length / itemsPerPage);

  // Load items based on current page
  useEffect(() => {
    const newData = data.slice(0, page * itemsPerPage);
    setVisibleData(newData);
  }, [page, data, itemsPerPage]);

  // Setup Intersection Observer
  useEffect(() => {
    if (page >= totalPages) return;

    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setPage(prev => prev + 1);
      }
    });

    const currentLoader = loaderRef.current;
    if (currentLoader) observer.observe(currentLoader);

    return () => {
      if (currentLoader) observer.unobserve(currentLoader);
    };
  }, [page, totalPages]); // Removed loaderRef from dependencies

  return { visibleData, loaderRef };
};

export default useInfiniteScroll;
